import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=566b2a0d&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=566b2a0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566b2a0d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('566b2a0d')) {
      api.createRecord('566b2a0d', component.options)
    } else {
      api.reload('566b2a0d', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=566b2a0d&scoped=true&", function () {
      api.rerender('566b2a0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2VQ9D8Ybu40qs/JS/comp/DateRangeExt.vue"
export default component.exports